"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TreeDoc_ofNode = exports.TreeDoc_merge = exports.TreeDoc_ofArray = exports.TreeDoc = void 0;
var _1 = require(".");
var ListUtil_1 = require("./core/ListUtil");
var LangUtil_1 = require("./core/LangUtil");
var TDNode_1 = require("./TDNode");
var TreeDoc = /** @class */ (function () {
    function TreeDoc(rootKey, uri) {
        if (rootKey === void 0) { rootKey = 'root'; }
        if (uri === void 0) { uri = null; }
        this.uri = uri;
        this.idMap = {};
        this.root = new TDNode_1.TDNode(this, "root");
        this.root.key = rootKey;
    }
    TreeDoc.ofArray = function () {
        var result = new TreeDoc();
        result.root.setType(_1.TDNodeType.ARRAY);
        return result;
    };
    /** Retrain only the sub-tree under the input node. */
    TreeDoc.prototype.retain = function (node) {
        node.setKey(this.root.key);
        this.root = node;
        node.parent = undefined;
        return this;
    };
    /**
     * Create a TreeDoc with array root node contains the input nodes. This method will mutate the input nodes without
     * copying them. So the original Treedoc and parent associated with nodes will be obsoleted.
     * For idMap merge, all the id will be reassigned as id + "_" + docId to avoid collision.
     */
    TreeDoc.merge = function (nodes) {
        var result = new TreeDoc();
        result.root.type = _1.TDNodeType.ARRAY;
        var docId = 0;
        for (var _i = 0, nodes_1 = nodes; _i < nodes_1.length; _i++) {
            var node = nodes_1[_i];
            node.setKey(undefined);
            result.idMap = __assign(__assign({}, result.idMap), ListUtil_1.ListUtil.mapKeys(node.doc.idMap, function (k) { return k + "_" + docId; }));
            node.foreach(function (n) {
                n.doc = result;
                LangUtil_1.LangUtil.doIfNotNull(n.getChild(TDNode_1.TDNode.REF_KEY), function (nRef) { return nRef.value += "_" + docId; });
                LangUtil_1.LangUtil.doIfNotNull(n.getChild(TDNode_1.TDNode.ID_KEY), function (nRef) { return nRef.value += "_" + docId; });
            });
            result.root.addChild(node);
            docId++;
        }
        return result;
    };
    /**
     * Build a tree node with exiting node as root node. This method will mutate input node so that the original doc and
     * parent associated with that node will be obsoleted. The that node is still associated with original doc, the original
     * doc will be in invalid state.
     */
    TreeDoc.ofNode = function (node) {
        var key = node.doc.root.key;
        var result = new TreeDoc(node.doc.root.key, node.doc.uri);
        result.root = node.setKey(key);
        result.idMap = __assign({}, node.doc.idMap);
        node.doc = result;
        node.parent = undefined;
        return result;
    };
    return TreeDoc;
}());
exports.TreeDoc = TreeDoc;
// Jest has problem to access static method. We have to define global method for Jest spec to access
function TreeDoc_ofArray() {
    return TreeDoc.ofArray();
}
exports.TreeDoc_ofArray = TreeDoc_ofArray;
function TreeDoc_merge(nodes) {
    return TreeDoc.merge(nodes);
}
exports.TreeDoc_merge = TreeDoc_merge;
function TreeDoc_ofNode(node) {
    return TreeDoc.ofNode(node);
}
exports.TreeDoc_ofNode = TreeDoc_ofNode;
//# sourceMappingURL=TreeDoc.js.map